// test2566
(2566 && 0);
